module.exports = __webpack_public_path__ + "static/media/Eterno Fabric Storage Ottoman_Green.d689876d.png";